module.exports = __webpack_public_path__ + "img/Pattern2.5a96c155.svg";